module.exports = __webpack_public_path__ + "static/img/titilog2.49524c0a.png";